import { Routes } from '@angular/router';
import { authGuard } from './auth/auth.guard';
import { parishGuard } from './auth/parish.guard';

export const routes: Routes = [
  {
    path: '',
    redirectTo: 'home',
    pathMatch: 'full'
  },
  {
    path: 'signin',
    canActivate: [parishGuard],
    loadComponent: () => import('./login/login.page').then((m) => m.LoginPage)
  },
  {
    path: 'logout',
    loadComponent: () => import('./logout/logout.component').then((m) => m.LogoutComponent)
  },
  {
    path: 'register/:email',
    loadComponent: () => import('./register/register.component').then((m) => m.RegisterComponent)
  },
  {
    path: 'ourparish',
    canActivate: [parishGuard],
    loadComponent: () =>
      import('./parish/parish.page').then((m) => m.ParishPage)
  },
  {
    path: 'myservice',
    canActivate: [parishGuard, authGuard],
    loadComponent: () => import('./my-class/my-class.page').then(m => m.MyClassPage)
  },
  {
    path: 'myservice/:profileType',
    canActivate: [parishGuard, authGuard],
    loadComponent: () => import('./my-class/my-class.page').then(m => m.MyClassPage)
  },
  {
    path: 'visitation-zones',
    canActivate: [parishGuard, authGuard],
    loadComponent: () => import('./visitations/visitation-zones.page').then(m => m.VisitationZonesPage)
  },
  {
    path: 'visitations',
    canActivate: [parishGuard, authGuard],
    loadComponent: () => import('./visitations/visitations.page').then(m => m.VisitationsPage)
  },
  {
    path: 'visitation-details/:visitationId',
    canActivate: [parishGuard, authGuard],
    loadComponent: () => import('./visitations/visitations-details.page').then(m => m.VisitationDetailsPage)
  },
  {
    path: 'parish',
    canActivate: [parishGuard],
    loadComponent: () => import('./parish/parish.page').then(m => m.ParishPage)
  },
  {
    path: 'feedback',
    loadComponent: () => import('./feedback/feedback.page').then(m => m.FeedbackPage)
  },
  {
    path: 'donate',
    canActivate: [parishGuard],
    loadComponent: () => import('./donations/donate/donate.component').then(m => m.DonateComponent)
  },
  {
    path: 'paymenthistory',
    canActivate: [parishGuard, authGuard],
    loadComponent: () => import('./donations/payment-history/payment-history.component').then(m => m.PaymentHistoryComponent)
  },
  {
    path: 'profile',
    canActivate: [parishGuard, authGuard],
    loadComponent: () => import('./profile-container/profile-container.component').then(m => m.ProfileContainerComponent)
  },
  {
    path: 'wallet',
    canActivate: [parishGuard, authGuard],
    loadComponent: () => import('./wallet/wallet.component').then(m => m.WalletComponent)
  },
  {
    path: 'assignments',
    canActivate: [parishGuard, authGuard],
    loadComponent: () => import('./profileassignment/profileassignment.page').then(m => m.ProfileassignmentPage)
  },
  {
    path: 'events',
    canActivate: [parishGuard, authGuard],
    loadComponent: () => import('./events/events/events.page').then(m => m.EventsPage)
  },
  {
    path: 'event-details/:eventid',
    canActivate: [parishGuard, authGuard],
    loadComponent: () => import('./events/event-details/event-details.page').then(m => m.EventDetailsPage)
  },
  {
    path: 'event-details/:eventid/:isscroll',
    canActivate: [parishGuard, authGuard],
    loadComponent: () => import('./events/event-details/event-details.page').then(m => m.EventDetailsPage)
  },
  {
    path: 'event-manage/:eventid',
    canActivate: [parishGuard, authGuard],
    loadComponent: () => import('./events/event-manage/event-manage.page').then(m => m.EventManagePage)
  },
  {
    path: 'livestream',
    canActivate: [parishGuard],
    loadComponent: () => import('./livestream/livestream.component').then(m => m.LivestreamComponent)
  },
  {
    path: 'home',
    canActivate: [parishGuard],
    loadComponent: () => import('./home/home.page').then(m => m.HomePage)
  },
  {
    path: 'contactus',
    canActivate: [parishGuard],
    loadComponent: () => import('./contact-us/contact-us.page').then(m => m.ContactUsPage)
  },
  {
    path: 'settings',
    canActivate: [parishGuard, authGuard],
    loadComponent: () => import('./settings/settings.page').then(m => m.SettingsPage)
  },
  {
    path: 'change-password',
    canActivate: [parishGuard, authGuard],
    loadComponent: () => import('./change-password/change-password.page').then(m => m.ChangePasswordPage)
  },
  {
    path: 'search',
    canActivate: [parishGuard, authGuard],
    loadComponent: () => import('./search/search.component').then(m => m.SearchComponent)
  },
  {
    path: 'reports',
    canActivate: [parishGuard, authGuard],
    loadComponent: () => import('./reports/reports.component').then(m => m.ReportsComponent)
  },
  {
    path: 'reports/:month/:year/:serviceid/:reportid',
    canActivate: [parishGuard, authGuard],
    loadComponent: () => import('./reports/reports.component').then(m => m.ReportsComponent)
  },
  {
    path: 'dashboard',
    canActivate: [parishGuard, authGuard],
    loadComponent: () => import('./dashboard/dashboard.component').then(m => m.DashboardComponent)
  },
  {
    path: 'classrooms',
    canActivate: [parishGuard, authGuard],
    loadComponent: () => import('./classroom/classroom.component').then(m => m.ClassroomComponent)
  },
  {
    path: 'forgotpassword/:username',
    canActivate: [parishGuard],
    loadComponent: () =>
      import('./forgot-password/forgot-password.component').then((m) => m.ForgotPasswordComponent)
  },
  {
    path: 'schedule',
    canActivate: [parishGuard],
    loadComponent: () => import('./schedule/schedule.component').then(m => m.ScheduleComponent)
  },
  {
    path: 'news',
    canActivate: [parishGuard],
    loadComponent: () => import('./news/news.component').then(m => m.NewsComponent)
  },
  {
    path: 'news-detail/:newsid',
    canActivate: [parishGuard],
    loadComponent: () => import('./news/news-detail/news-detail.component').then(m => m.NewsDetailComponent)
  },
  {
    path: 'menu',
    canActivate: [parishGuard],
    loadComponent: () => import('./menu/menu.component').then(m => m.MenuComponent)
  },
  {
    path: 'external-resources',
    canActivate: [parishGuard],
    loadComponent: () => import('./external-resources/external-resources.component').then(m => m.ExternalResourcesComponent)
  },
  {
    path: '',
    canActivate: [parishGuard],
    loadComponent: () => import('./my-class/google-map/google-map.component').then(m => m.GoogleMapComponent)
  },
  {
    path: 'messages',
    canActivate: [parishGuard, authGuard],
    loadComponent: () => import('./message-center/message-center.component').then(m => m.MessageCenterComponent)
  },
  {
    path: 'companylist',
    loadComponent: () => import('./company-selector/company-selector.component').then(m => m.CompanySelectorComponent)
  },
  {
    path: 'home',
    canActivate: [parishGuard],
    loadComponent: () => import('./home/home.page').then(m => m.HomePage)
  },
  {
    path: 'parish-list',
    loadComponent: () => import('./company-selector/company-selector.component').then(m => m.CompanySelectorComponent)
  },
  {
    path: 'whatsapp-settings',
    canActivate: [parishGuard, authGuard],
    loadComponent: () => import('./whatsapp/whatsapp.page').then(m => m.WhatsappPage)
  },
  {
    path: 'families-manage',
    canActivate: [parishGuard, authGuard],
    loadComponent: () => import('./families-manage/families-manage.component').then(m => m.FamiliesManageComponent)
  },
  {
    path: 'families-manage/:id',
    canActivate: [parishGuard, authGuard],
    loadComponent: () => import('./families-manage/families-manage.component').then(m => m.FamiliesManageComponent)
  },
];
